import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ComputerVisionPage from "@/pages/service/ComputerVisionPage";

export const Route = createFileRoute("/service/computer-vision")({
  head: () => pageHead("Computer Vision & Perception", "Image and video analysis, document intelligence, quality inspection, and edge vision deployment for enterprise applications.", "/service/computer-vision", false),
  component: ComputerVisionPage,
});
